export default __webpack_public_path__ + "images/bee_not_found.9ac61ef.png";